import { AxiosResponse } from 'axios';
import { HOTEL_AI_URL } from '../../../../config';
import reservationAxios from '../../../../utils/axios/reservation.axios';
import { PaginatedAgentActivities } from '../../../../interfaces/agent-activitites/paginatedStore.type';

const tryToFetchActivities = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<PaginatedAgentActivities>> => {
    const url = `${HOTEL_AI_URL}/ai-agents-logs?page=${pageNumber}&size=${pageSize}`;
    return reservationAxios.put<PaginatedAgentActivities>(url, data)
}

export const AgentActivitiesService = {
    tryToFetchActivities,
}